//   import React, { useEffect, useState, useRef, useCallback } from "react";
//   import { useNavigate } from "react-router-dom";
//   import { getdata, getLogoContent } from "../api/service";
//   import { Html5QrcodeScanner } from "html5-qrcode";
//   import QRScanner from './QRScanner';
//   import { FiAlertTriangle } from "react-icons/fi";

//   const BASE_API = "https://uat-ecom.azurewebsites.net";

//   function QREntryPage() {
//     const navigate = useNavigate();
//     const [status, setStatus] = useState("scanning");
//     const [progress, setProgress] = useState(0);
//     const [tableInfo, setTableInfo] = useState(null);
//     const [error, setError] = useState(null);
//     const [distanceInfo, setDistanceInfo] = useState(null);
//     const [cameraActive, setCameraActive] = useState(false);
//     const [cameraError, setCameraError] = useState(null);
//     const [scanFeedback, setScanFeedback] = useState(null);

//     const hasNavigated = useRef(false);
//     const videoRef = useRef(null);
//     const canvasRef = useRef(null);
//     const streamRef = useRef(null);
//     const scanLoopRef = useRef(null);
//     const jsQRRef = useRef(null);
//     const fileInputRef = useRef(null); // ── native camera input ref
// const [torchSupported, setTorchSupported] = useState(false);
// const [torchOn, setTorchOn] = useState(false);

// const videoTrackRef = useRef(null);
//     const DEMO_TABLE_NO = "1302";
//     const DEMO_STORE_ID = "567";
//     const DEMO_COMPANY_ID = "5";
//   const [showScanner, setShowScanner] = useState(false);
//     const handleDemoMode = () => {
//       if (hasNavigated.current) return;
//       stopCamera();
//       processQRScan(DEMO_TABLE_NO, DEMO_STORE_ID, DEMO_COMPANY_ID);
//     };

//     // ── Load jsQR dynamically ─────────────────────────────────────────────────
//     const loadJsQR = useCallback(() => {
//       return new Promise((resolve, reject) => {
//         if (jsQRRef.current) return resolve(jsQRRef.current);
//         if (window.jsQR) { jsQRRef.current = window.jsQR; return resolve(window.jsQR); }
//         const script = document.createElement("script");
//         script.src = "https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js";
//         script.onload = () => { jsQRRef.current = window.jsQR; resolve(window.jsQR); };
//         script.onerror = () => reject(new Error("Failed to load QR scanner"));
//         document.head.appendChild(script);
//       });
//     }, []);

//     // ── Parse QR result URL ───────────────────────────────────────────────────
//     // const parseQRUrl = (text) => {
//     //   try {
//     //     let url;
//     //     try { url = new URL(text); } catch { return null; }
//     //     let tableNo = url.searchParams.get("table");
//     //     let storeId = url.searchParams.get("storeId");
//     //     let companyId = url.searchParams.get("companyId");
//     //     if (!tableNo && url.hash?.includes("?")) {
//     //       const hashQuery = url.hash.split("?")[1];
//     //       const hashParams = new URLSearchParams(hashQuery);
//     //       tableNo = hashParams.get("table");
//     //       storeId = hashParams.get("storeId");
//     //       companyId = hashParams.get("companyId");
//     //     }
//     //     if (tableNo) return { tableNo, storeId, companyId };
//     //     return null;
//     const parseQRUrl = (text) => {
//   try {
//     let url;
//     try { url = new URL(text); } catch { return null; }

//     // ── Handle new base64 token format (?q=...) ──
//     const token = url.searchParams.get("q");
//     if (token) {
//       try {
//         const decoded = atob(token);
//         const [tableNo, storeId, companyId] = decoded.split("|");
//         if (tableNo) return { tableNo, storeId, companyId };
//       } 
//       catch { return null; }
//     };
//       let tableNo = url.searchParams.get("table");
//     let storeId = url.searchParams.get("storeId");
//     let companyId = url.searchParams.get("companyId");

//     if (!tableNo && url.hash?.includes("?")) {
//       const hashQuery = url.hash.split("?")[1];
//       const hashParams = new URLSearchParams(hashQuery);
//       tableNo = tableNo || hashParams.get("table");
//       storeId = storeId || hashParams.get("storeId");
//       companyId = companyId || hashParams.get("companyId");

//       // also check hash for q-token
//       if (!tableNo) {
//         const hashToken = hashParams.get("q");
//         if (hashToken) {
//           try {
//             const decoded = atob(hashToken);
//             const [hTableNo, hStoreId, hCompanyId] = decoded.split("|");
//             if (hTableNo) return { tableNo: hTableNo, storeId: hStoreId, companyId: hCompanyId };
//           } catch {}
//         }
//       }
//     }

//     if (tableNo) return { tableNo, storeId, companyId };
//     return null;
//   } catch {
//     return null;
//   }
// };



//     // ── Stop camera stream ────────────────────────────────────────────────────
//     const stopCamera = useCallback(() => {
//       if (scanLoopRef.current) cancelAnimationFrame(scanLoopRef.current);
//       if (streamRef.current) {
//         streamRef.current.getTracks().forEach(t => t.stop());
//         streamRef.current = null;
//       }
//       setCameraActive(false);
//     }, []);

//     // ── Native camera: open mobile camera app directly ────────────────────────
//     const handleNativeCameraOpen = () => {
//       setCameraError(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = ""; // reset so same file can be picked again
//         fileInputRef.current.click();
//       }
//     };

//     // ── Native camera: process captured photo → scan QR ──────────────────────
//     // const handleFileCapture = async (e) => {
//     //   const file = e.target.files[0];
//     //   if (!file) return;

//     //   try {
//     //     const jsQR = await loadJsQR();

//     //     const reader = new FileReader();
//     //     reader.onload = (event) => {
//     //       const img = new Image();
//     //       img.onload = () => {
//     //         const canvas = canvasRef.current;
//     //         canvas.width = img.width;
//     //         canvas.height = img.height;
//     //         const ctx = canvas.getContext("2d");
//     //         ctx.drawImage(img, 0, 0);
//     //         const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//     //         const code = jsQR(imageData.data, imageData.width, imageData.height, {
//     //           inversionAttempts: "dontInvert",
//     //         });
//     //         if (code?.data) {
//     //           const parsed = parseQRUrl(code.data);
//     //           if (parsed) {
//     //             processQRScan(parsed.tableNo, parsed.storeId, parsed.companyId);
//     //           } else {
//     //             setCameraError("QR found but not a valid table QR. Please try again.");
//     //           }
//     //         } else {
//     //           setCameraError("No QR code detected in the photo. Please try again.");
//     //         }
//     //       };
//     //       img.src = event.target.result;
//     //     };
//     //     reader.readAsDataURL(file);
//     //   } catch (err) {
//     //     setCameraError("Could not process photo. Please try again.");
//     //   }
//     // };
//   const handleScan = (text) => {
//     setShowScanner(false);

//     const parsed = parseQRUrl(text);

//     if (parsed) {
//       processQRScan(
//         parsed.tableNo,
//         parsed.storeId,
//         parsed.companyId
//       );
//     } else {
//       setCameraError("Invalid QR Code");
//     }
//   };
//     // ── Live browser scan (HTTPS only fallback) ───────────────────────────────
//     const startCamera = useCallback(async () => {
//       setCameraError(null);
//       setScanFeedback(null);
//       if (!window.isSecureContext) {
//         setCameraError("Camera requires HTTPS. Please open this page over a secure connection.");
//         return;
//       }
//       if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//         setCameraError("Live scan not supported on this browser. Use the camera button above.");
//         return;
//       }
//       try {
//         const jsQR = await loadJsQR();
//         const stream = await navigator.mediaDevices.getUserMedia({
//           video: {
//             facingMode: { ideal: "environment" },
//             width: { ideal: 1280 },
//             height: { ideal: 720 },
//           }
//         });
//         streamRef.current = stream;
//         setCameraActive(true);
//         await new Promise(r => setTimeout(r, 100));
//         if (videoRef.current) {
//           videoRef.current.srcObject = stream;
//           await videoRef.current.play();
//         }
//         const scan = () => {
//           if (!videoRef.current || !canvasRef.current) return;
//           const video = videoRef.current;
//           const canvas = canvasRef.current;
//           if (video.readyState === video.HAVE_ENOUGH_DATA) {
//             canvas.width = video.videoWidth;
//             canvas.height = video.videoHeight;
//             const ctx = canvas.getContext("2d");
//             ctx.drawImage(video, 0, 0);
//             const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//             const code = jsQR(imageData.data, imageData.width, imageData.height, {
//               inversionAttempts: "dontInvert",
//             });
//             if (code?.data) {
//               const parsed = parseQRUrl(code.data);
//               if (parsed) {
//                 setScanFeedback("QR detected! Processing...");
//                 stopCamera();
//                 processQRScan(parsed.tableNo, parsed.storeId, parsed.companyId);
//                 return;
//               } else {
//                 setScanFeedback("QR found but not a valid table QR");
//               }
//             }
//           }
//           scanLoopRef.current = requestAnimationFrame(scan);
//         };
//         scanLoopRef.current = requestAnimationFrame(scan);
//       } catch (err) {
//         setCameraActive(false);
//         if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
//           setCameraError("Camera access denied. Please allow camera permission and try again.");
//         } else if (err.name === "NotFoundError") {
//           setCameraError("No camera found on this device.");
//         } else {
//           setCameraError(err.message || "Could not open camera.");
//         }
//       }
//     }, [loadJsQR, stopCamera]);

//     // ── Smart open: native camera on mobile, live scan on desktop ────────────
//   const handleOpenCamera = () => {
//     // ── Tap effect ──────────────────────────────
//     const btn = document.getElementById("camOpenBtn");
//     const icon = document.getElementById("camBtnIcon");
//     const r1 = document.getElementById("camRipple1");
//     const r2 = document.getElementById("camRipple2");

//     if (btn) { btn.style.transform = "scale(0.92)"; btn.style.animation = "none"; }
//     if (icon) icon.style.animation = "iconSpin 0.4s ease both";
//     if (r1) r1.style.animation = "rippleGo 0.65s ease-out both";
//     setTimeout(() => { if (r2) r2.style.animation = "rippleGo 0.65s ease-out both"; }, 180);
//     setTimeout(() => {
//       if (btn) { btn.style.transform = ""; btn.style.animation = "camPulse 2.5s ease-in-out infinite"; }
//       if (icon) icon.style.animation = "";
//       if (r1) r1.style.animation = "";
//       if (r2) r2.style.animation = "";
//     }, 700);
//     // ────────────────────────────────────────────

//     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
//     if (isMobile) {
//       setShowScanner(true);;
//     } else {
//       startCamera();
//     }
//   };
//     // ── Cleanup on unmount ────────────────────────────────────────────────────
//     useEffect(() => {
//       return () => stopCamera();
//     }, [stopCamera]);

//     // ── URL param extraction ──────────────────────────────────────────────────
//     useEffect(() => {
//     const extractParams = () => {
//     const searchParams = new URLSearchParams(window.location.search);
//     const hash = window.location.hash;

//     let token = searchParams.get("q");

//     if (!token && hash.includes("?")) {
//       const hashParams = new URLSearchParams(hash.split("?")[1]);
//       token = hashParams.get("q");
//     }

//     if (token) {
//       try {
//         const decoded = atob(token);
//         const [tableNo, storeId, companyId] = decoded.split("|");
//         if (tableNo) {
//           //  Clean URL immediately — nothing shows in browser bar
//           window.history.replaceState({}, document.title, window.location.pathname);
//           return { tableNo, storeId, companyId };
//         }
//       } catch {}
//     }

//     // Fallback plain params
//     let tableNo = searchParams.get("table");
//     let storeId = searchParams.get("storeId");
//     let companyId = searchParams.get("companyId");

//     if (!tableNo && hash.includes("?")) {
//       const hashParams = new URLSearchParams(hash.split("?")[1]);
//       tableNo = hashParams.get("table");
//       storeId = hashParams.get("storeId");
//       companyId = hashParams.get("companyId");
//     }

//     if (tableNo) {
//       // ✅ Clean plain params too
//       window.history.replaceState({}, document.title, window.location.pathname);
//     }

//     return { tableNo, storeId, companyId };
//   };
//       const { tableNo, storeId, companyId } = extractParams();
//       if (tableNo) {
//         processQRScan(tableNo, storeId, companyId);
//       } else {
//         setStatus("ready");
//       }
//       const onHashChange = () => {
//         if (hasNavigated.current) return;
//         const { tableNo, storeId, companyId } = extractParams();
//         if (tableNo) processQRScan(tableNo, storeId, companyId);
//       };
//       window.addEventListener("hashchange", onHashChange);
//       return () => window.removeEventListener("hashchange", onHashChange);
//     }, []);

//     // ── Main QR process ───────────────────────────────────────────────────────
//     const processQRScan = async (tableNo, storeId, companyId) => {
//       if (hasNavigated.current) return;
//       hasNavigated.current = true;
//       localStorage.removeItem("cart");
//       localStorage.removeItem("selectedFreeItems");
//       localStorage.removeItem("allowedFreeQty");
//       try {
//         setStatus("gps");
//         setProgress(10);
//         const isSecureOrigin =
//           window.location.protocol === "https:" ||
//           window.location.hostname === "localhost" ||
//           window.location.hostname === "127.0.0.1";
          
//         let customerLat = null;
//         let customerLng = null;
//         if (isSecureOrigin && navigator.geolocation) {
//           const position = await new Promise((resolve, reject) => {
//             navigator.geolocation.getCurrentPosition(resolve, reject, {
//               enableHighAccuracy: true, timeout: 12000, maximumAge: 0,
//             });
//           });
//           customerLat = position.coords.latitude;
//           customerLng = position.coords.longitude;
//         }
//         setProgress(30);
//         setStatus("processing");
//         const tableRes = await fetch(`${BASE_API}/api/Sos/table-info?diningTableId=${tableNo}`);
//         const tableData = await tableRes.json();
//         if (!tableData?.data) throw new Error("Table not found");
//         const { storeId: tableStoreId, companyId: tableCompanyId, dineTableid } = tableData.data;
//         setProgress(55);
//         if (customerLat !== null && customerLng !== null) {
//           const validationRes = await fetch(`${BASE_API}/api/Sos/validate-table-location`, {
//             method: "POST", headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({
//               diningTableId: parseInt(tableNo),
//               customerLatitude: customerLat, customerLongitude: customerLng,
//               storeId: tableStoreId, companyId: tableCompanyId,
//             }),
//           });
//           const validationResult = await validationRes.json();
//           localStorage.setItem("tableName", validationResult.tableName?.trim());
//           setDistanceInfo({ distance: validationResult.distanceMeters, allowed: validationResult.allowedRadius });
//           if (!validationResult.isAllowed) {
//             setStatus("location_error"); setError(validationResult.message);
//             hasNavigated.current = false; return;
//           }
//         }
//         setProgress(75);
//         const finalStoreId = tableStoreId || storeId;
//         const finalCompanyId = tableCompanyId || companyId;
//         const dataRes = await getdata(finalCompanyId, finalStoreId);
//         const info = dataRes?.datas?.[0];
//         const companyName = info?.companyName || "Restaurant";
//         const storeName = info?.storeName || "Branch";
//         let logoUrl = "";
//         try {
//           const logoRes = await getLogoContent(finalCompanyId);
//           logoUrl = logoRes?.logo?.[0]?.url || "https://bizdomfs.blob.core.windows.net/post-image/default.png";
//         } catch { logoUrl = "https://bizdomfs.blob.core.windows.net/post-image/default.png"; }
//         localStorage.setItem("qrTableNumber", tableNo);
//         localStorage.setItem("StoreId", finalStoreId);
//         localStorage.setItem("compId", finalCompanyId);
//         localStorage.setItem("CompanyName", companyName);
//         localStorage.setItem("StoreName", storeName);
//         localStorage.setItem("logo", logoUrl);
//         localStorage.setItem("orderType", "Dine In");
//         localStorage.setItem("ordertypeId", "1");
//         localStorage.setItem("layoutPosition", "top");
//         localStorage.setItem("dineTableid", dineTableid || tableNo);
//          localStorage.setItem("qrVerifiedAt", Date.now().toString()); 
//         setTableInfo({ number: tableNo, storeId: finalStoreId, companyId: finalCompanyId, companyName, storeName });
//         setProgress(100);
//         setStatus("success");
//         setTimeout(() => {
//           navigate("/menu", { replace: true, state: { tableNo, storeId: finalStoreId, companyId: finalCompanyId, isQROrder: true } });
//         }, 1200);
//       } catch (err) {
//         console.error("QR process error:", err);
//         if (err.code === 1 || err.message?.toLowerCase().includes("denied")) {
//           setStatus("gps_denied"); setError("Location access was denied. Please enable GPS and try again.");
//         } else if (err.code === 2 || err.code === 3) {
//           setStatus("gps_error"); setError("Could not get your location. Check your GPS and try again.");
//         } else {
//           setStatus("error"); setError(err.message || "QR processing failed");
//         }
//         hasNavigated.current = false;
//       }
//     };

//     const ProgressBar = () => (
//       <div style={styles.progressContainer}>
//         <div style={{ ...styles.progressBar, width: `${progress}%` }}>
//           <div style={styles.progressGlow} />
//         </div>
//         <div style={styles.progressPct}>{progress}%</div>
//       </div>
//     );

//     const renderContent = () => {
//       switch (status) {
//         case "ready":
//           return (
//             <div style={styles.centerBox}>
//               <p style={styles.sub}>Point your camera at the QR code on your table</p>

//               {/* ── Hidden native file input (opens mobile camera app) ── */}
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 capture="environment"
//                 style={{ display: "none" }}
              
//               />

//               {/* ── Hidden canvas for QR decoding ── */}
//               <canvas ref={canvasRef} style={{ display: "none" }} />

//               {/* ── Live camera viewer (desktop / HTTPS fallback) ── */}
//               {cameraActive ? (
//                 <div style={styles.cameraWrap}>
//                   <video
//                     ref={videoRef}
//                     style={styles.cameraVideo}
//                     playsInline
//                     muted
//                     autoPlay
//                   />
//                   <div style={styles.scanOverlay}>
//                     <div style={styles.scanBox}>
//                       <div style={{ ...styles.scanCorner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
//                       <div style={{ ...styles.scanCorner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
//                       <div style={{ ...styles.scanCorner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
//                       <div style={{ ...styles.scanCorner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
//                       <div style={styles.scanLine} />
//                     </div>
//                     <p style={styles.scanHint}>
//                       {scanFeedback || "Align QR code within the frame"}
//                     </p>
//                   </div>
//                   <button onClick={stopCamera} style={styles.closeCameraBtn}>✕ Close</button>
//                 </div>
//               ) : (
//                 <>
//                   {/* Static scan frame */}
//                   <div style={styles.scanFrame}>
//                     <div style={styles.scanLineStatic} />
//                     <div style={{ ...styles.corner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
//                     <div style={{ ...styles.corner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
//                     <div style={{ ...styles.corner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
//                     <div style={{ ...styles.corner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
//                   </div>

//                   {cameraError && (
//                     <div style={styles.cameraErrorBox}>
//                       <span style={{ fontSize: 16 }}>⚠️</span>
//                       <span style={{ fontSize: 12, color: "#9b0d22" }}>{cameraError}</span>
//                     </div>
//                   )}

//                   {/* ── Primary Open Camera Button ── */}
//                   <div style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
//     <span id="camRipple1" style={styles.rippleEl} />
//     <span id="camRipple2" style={styles.rippleEl} />
//     {/* <button id="camOpenBtn" onClick={handleOpenCamera} style={styles.openCameraBtn}>
//       <span style={styles.camIconWrap}>
//         <span style={styles.camRing} />
//         <span style={{ ...styles.camRing, animationDelay: "0.7s" }} />
//         <svg id="camBtnIcon" width="22" height="22" viewBox="0 0 24 24"
//           fill="none" stroke="currentColor" strokeWidth="2.2"
//           strokeLinecap="round" strokeLinejoin="round"
//           style={{ transition: "transform 0.3s" }}>
//           <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
//           <circle cx="12" cy="13" r="4"/>
//         </svg>
//       </span>
//       <span style={styles.btnShimmer} />
//       Open Camera &amp; Scan QR
//     </button> */}

//   <button
//     onClick={() => setShowScanner(true)}
//     style={styles.openCameraBtn}
//   >
//     📷 Open Camera & Scan QR
//   </button>
//   {showScanner && (
//     <QRScanner
//       onScan={handleScan}
//       onClose={() => setShowScanner(false)}
//     />
//   )}
//   </div>
//   {/* <p style={styles.camHint}>Tap to open rear camera</p> */}

//                   <p style={styles.gpsNote}>
//                     📍 GPS location verified automatically after scan
//                   </p>

//                   <button onClick={handleDemoMode} style={styles.demoBtn}>
//                     Demo Mode
//                   </button>
//                 </>
//               )}
//             </div>
//           );

//         case "gps":
//           return (
//             <div style={styles.centerBox}>
//               <div style={styles.pulseWrap}>
//                 <div style={{ ...styles.pulseRing, animationDelay: "0s" }} />
//                 <div style={{ ...styles.pulseRing, animationDelay: "0.5s" }} />
//                 <span style={{ fontSize: 32 }}>📍</span>
//               </div>
//               <h2 style={styles.h2}>Getting Your Location</h2>
//               <p style={styles.sub}>Please allow location access when prompted</p>
//               <ProgressBar />
//             </div>
//           );

//         case "processing":
//           return (
//             <div style={styles.centerBox}>
//               <div style={styles.spinner} />
//               <h2 style={styles.h2}>Verifying Location...</h2>
//               <p style={styles.sub}>Checking if you are near the table</p>
//               <ProgressBar />
//             </div>
//           );

//         case "success":
//           return (
//             <div style={styles.centerBox}>
//               <div style={styles.successCircle}>
//                 <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
//                   <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" />
//                 </svg>
//               </div>
//               {/* <h2 style={styles.h2}>Welcome! {localStorage.getItem("tableName")}</h2> */}
//               <h2 style={styles.h2}>Welcome! {tableInfo?.companyName}</h2>
//               {/* <p style={{ ...styles.sub, color: "#c8102e", fontWeight: 600, fontSize: 16 }}>{tableInfo?.companyName}</p> */}
//               <p style={styles.sub}>{tableInfo?.storeName}</p>
//               {distanceInfo && (
//                 <p style={styles.distanceBadge}>📍 You are {Math.round(distanceInfo.distance)}m from the table</p>
//               )}
//               <p style={{ ...styles.sub, color: "#999", marginTop: 16 }}>Taking you to the menu...</p>
//             </div>
//           );

//         case "location_error":
//           return (
//             <div style={styles.centerBox}>
//               <span style={{ fontSize: 48 }}>📍</span>
//               <h2 style={{ ...styles.h2, color: "#c8102e" }}>Too Far from Table</h2>
//               <p style={styles.sub}>{error}</p>
//               {distanceInfo && (
//                 <div style={styles.distanceCard}>
//                   <div style={styles.distanceRow}>
//                     <span style={styles.distanceLabel}>Your distance</span>
//                     <span style={{ ...styles.distanceValue, color: "#c8102e" }}>{Math.round(distanceInfo.distance)}m</span>
//                   </div>
//                 </div>
//               )}
//               <p style={styles.locationHint}>Please move closer to the table and try again</p>
//               <button onClick={() => { hasNavigated.current = false; window.location.reload(); }} style={styles.retryBtn}>Try Again</button>
//             </div>
//           );

//         case "gps_denied":
//           return (
//             <div style={styles.centerBox}>
//               <span style={{ fontSize: 56 }}>🚫</span>
//               <h2 style={{ ...styles.h2, marginTop: 16 }}>Location Access Denied</h2>
//               <p style={styles.sub}>This app requires location access to verify you are at the correct table.</p>
//               <div style={styles.instructionBox}>
//                 <p style={styles.instructionTitle}>How to enable location:</p>
//                 <p style={styles.instructionStep}>1. Tap the lock icon in your browser address bar</p>
//                 <p style={styles.instructionStep}>2. Find "Location" and set it to "Allow"</p>
//                 <p style={styles.instructionStep}>3. Reload the page and scan again</p>
//               </div>
//               <button onClick={() => window.location.reload()} style={styles.retryBtn}>Reload & Try Again</button>
//             </div>
//           );

//         case "gps_error":
//           return (
//             <div style={styles.centerBox}>
//               <span style={{ fontSize: 56 }}>📡</span>
//               <h2 style={{ ...styles.h2, marginTop: 16 }}>Location Not Found</h2>
//               <p style={styles.sub}>Could not detect your GPS location. Make sure your device GPS is turned on.</p>
//               <button onClick={() => { hasNavigated.current = false; window.location.reload(); }} style={styles.retryBtn}>Try Again</button>
//             </div>
//           );

//         case "error":
//           return (
//             <div style={styles.centerBox}>
//               <span style={{ fontSize: 56 }}>⚠️</span>
//               <h2 style={{ ...styles.h2, marginTop: 16 }}>Unable to Process QR Code</h2>
//               <p style={styles.sub}>{error || "Failed to process QR code"}</p>
//               <button onClick={() => window.location.reload()} style={styles.retryBtn}>Try Again</button>
//             </div>
//           );

//         default: return null;
//       }
//     };

//     return (
//       <div  style={styles.page}>
//         <style>{`
//     @keyframes spin        { to { transform: rotate(360deg); } }
//     @keyframes pulse       { 0% { transform: scale(0.8); opacity: 1; } 100% { transform: scale(2); opacity: 0; } }
//     @keyframes slideUp     { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
//     @keyframes shimmer     { 0% { transform: translateX(-100%); } 100% { transform: translateX(400%); } }
//     @keyframes scanMove       { 0% { top: 8px; opacity: 0.4; } 50% { opacity: 1; } 100% { top: calc(100% - 11px); opacity: 0.4; } }
//     @keyframes scanMoveStatic { 0% { top: 10px; opacity: 0.3; } 50% { opacity: 1; } 100% { top: 150px; opacity: 0.3; } }
//     @keyframes camBtnPulse { 0%,100% { box-shadow: 0 4px 24px rgba(200,16,46,0.35); } 50% { box-shadow: 0 4px 36px rgba(200,16,46,0.6); } }
//     @keyframes iconSpin    { 0% { transform: rotate(0deg) scale(1); } 40% { transform: rotate(-18deg) scale(1.2); } 100% { transform: rotate(0deg) scale(1); } }
//     @keyframes rippleGo    { 0% { transform: scale(1); opacity: 0.6; } 100% { transform: scale(2.8); opacity: 0; } }
//     @keyframes camPulse    { 0%,100% { transform: scale(1); } 50% { transform: scale(1.04); } }
//   `}</style>
//         <div style={styles.card}>
//           <div style={styles.header}>
//             <h1 style={styles.title}>Scan & Order</h1>
//             <p style={styles.subtitle}>Contactless dining order experience</p>
//           </div>
//           <div style={styles.content}>{renderContent()}</div>
//         </div>
//       </div>
//     );
//   }

//   const styles = {
//     page: {
//       minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
//       fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//       padding: 16, background: "#fff0f0",
//     },
//     card: {
//       width: "100%", maxWidth: 460, background: "#fff",
//       borderRadius: 32, padding: "32px 24px",
//       boxShadow: "0 8px 40px rgba(200,16,46,0.12)",
//       animation: "slideUp 0.5s ease-out",
//       border: "1px solid #fde8e8",
//     },
//     header: { textAlign: "center", marginBottom: 28 },
//     title: { fontSize: 28, fontWeight: 800, color: "#c8102e", margin: 0, letterSpacing: "-0.5px" },
//     subtitle: { color: "#b0a0a0", fontSize: 13, marginTop: 6 },
//     content: { minHeight: 360, display: "flex", alignItems: "center", justifyContent: "center" },
//     centerBox: { textAlign: "center", width: "100%" },
//     h2: { fontSize: 20, color: "#1a1a1a", margin: "16px 0 8px", fontWeight: 700 },
//     sub: { color: "#888", fontSize: 14, lineHeight: 1.6, margin: "4px 16px" },

//     // ── Open Camera Button ────────────────────────────────────────────────────
//     openCameraBtn: {
//       position: "relative",
//       overflow: "hidden",
//       marginTop: 20,
//       display: "inline-flex",
//       alignItems: "center",
//       gap: 12,
//       background: "#c8102e",
//       color: "#fff",
//       border: "none",
//       padding: "16px 32px",
//       borderRadius: 56,
//       fontSize: 15,
//       fontWeight: 700,
//       cursor: "pointer",
//       letterSpacing: 0.3,
//       boxShadow: "0 4px 24px rgba(200,16,46,0.35)",
//       WebkitTapHighlightColor: "transparent",
//       animation: "camBtnPulse 2.5s ease-in-out infinite",
//       transition: "transform 0.15s",
//     },
//     camIconWrap: {
//       position: "relative",
//       width: 28,
//       height: 28,
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       flexShrink: 0,
//     },
//     camRing: {
//       position: "absolute",
//       inset: -4,
//       border: "2px solid rgba(255,255,255,0.55)",
//       borderRadius: "50%",
//       animation: "pulse 1.8s ease-out infinite",
//     },
//     btnShimmer: {
//       position: "absolute",
//       top: 0,
//       left: "-30%",
//       width: "30%",
//       height: "100%",
//       background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.22), transparent)",
//       animation: "shimmer 2.4s ease-in-out infinite",
//       pointerEvents: "none",
//     },
//     camHint: {
//       marginTop: 10,
//       fontSize: 12,
//       color: "#aaa",
//       letterSpacing: 0.2,
//     },

//     // ── Camera viewer ─────────────────────────────────────────────────────────
//     cameraWrap: {
//       position: "relative", width: "100%", borderRadius: 20, overflow: "hidden",
//       background: "#000", marginBottom: 16, aspectRatio: "4/3",
//     },
//     cameraVideo: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
//     scanOverlay: {
//       position: "absolute", inset: 0, display: "flex", flexDirection: "column",
//       alignItems: "center", justifyContent: "center",
//     },
//     scanBox: { position: "relative", width: 200, height: 200, background: "rgba(255,255,255,0.05)" },
//     scanCorner: { position: "absolute", width: 28, height: 28, border: "3px solid #c8102e", borderRadius: 3 },
//     scanLine: {
//       position: "absolute", left: 6, right: 6, height: 3,
//       background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
//       borderRadius: 10, animation: "scanMove 1.8s linear infinite",
//     },
//     scanHint: {
//       marginTop: 16, color: "#fff", fontSize: 12, fontWeight: 600,
//       background: "rgba(0,0,0,0.5)", padding: "6px 16px", borderRadius: 20, letterSpacing: 0.3,
//     },
//     closeCameraBtn: {
//       position: "absolute", top: 12, right: 12,
//       background: "rgba(0,0,0,0.6)", color: "#fff", border: "none",
//       borderRadius: 20, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer",
//     },

//     // ── Error box ─────────────────────────────────────────────────────────────
//     cameraErrorBox: {
//       display: "flex", alignItems: "center", gap: 8,
//       background: "#fdecea", border: "1px solid #f5c6c6",
//       borderRadius: 12, padding: "10px 16px", margin: "12px 0", textAlign: "left",
//     },

//     // ── Static scan frame ─────────────────────────────────────────────────────
//     scanFrame: {
//       position: "relative", width: 180, height: 180,
//       margin: "16px auto", background: "rgba(200,16,46,0.04)",
//       borderRadius: 20, overflow: "hidden",
//     },
//     scanLineStatic: {
//       position: "absolute", left: 10, right: 10, height: 3,
//       background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
//       borderRadius: 10, animation: "scanMoveStatic 2s linear infinite",
//     },
//     corner: { position: "absolute", width: 36, height: 36, border: "3px solid #c8102e", borderRadius: 4 },

//     gpsNote: {
//       marginTop: 16, color: "#c8102e", fontSize: 12, fontWeight: 600,
//       background: "#fdecea", padding: "8px 16px", borderRadius: 20,
//       display: "inline-block", border: "1px solid #f5c6c6",
//     },
//     demoBtn: {
//       marginTop: 14, padding: "11px 26px", borderRadius: 30,
//       border: "1px solid #f5c6c6", background: "#fff0f0",
//       color: "#c8102e", fontSize: 13, fontWeight: 600, cursor: "pointer",
//     },

//     // ── Shared states ─────────────────────────────────────────────────────────
//     pulseWrap: {
//       position: "relative", width: 80, height: 80, margin: "0 auto 20px",
//       display: "flex", alignItems: "center", justifyContent: "center",
//     },
//     pulseRing: {
//       position: "absolute", inset: 0, border: "3px solid #c8102e",
//       borderRadius: "50%", animation: "pulse 1.5s ease-out infinite",
//     },
//     spinner: {
//       width: 56, height: 56, margin: "0 auto 20px",
//       border: "4px solid #fde8e8", borderTop: "4px solid #c8102e",
//       borderRadius: "50%", animation: "spin 0.9s linear infinite",
//     },
//     successCircle: {
//       width: 80, height: 80, margin: "0 auto 16px",
//       background: "#c8102e", borderRadius: "50%",
//       display: "flex", alignItems: "center", justifyContent: "center",
//     },
//     distanceBadge: {
//       marginTop: 12, color: "#16a34a", fontSize: 13, fontWeight: 600,
//       background: "#e8f5e9", padding: "6px 14px", borderRadius: 20,
//       display: "inline-block", border: "1px solid #a5d6a7",
//     },
//     distanceCard: {
//       margin: "16px auto", background: "#fdecea", border: "1px solid #f5c6c6",
//       borderRadius: 12, padding: "12px 20px", maxWidth: 240,
//     },
//     distanceRow: { display: "flex", justifyContent: "space-between", padding: "4px 0" },
//     distanceLabel: { fontSize: 13, color: "#9b0d22" },
//     distanceValue: { fontSize: 13, fontWeight: 700 },
//     locationHint: { color: "#b0a0a0", fontSize: 12, marginTop: 12 },
//     instructionBox: {
//       background: "#fdecea", border: "1px solid #f5c6c6",
//       borderRadius: 12, padding: "14px 18px", margin: "16px 0", textAlign: "left",
//     },
//     instructionTitle: { fontWeight: 700, color: "#9b0d22", fontSize: 13, marginBottom: 8 },
//     instructionStep: { color: "#c8102e", fontSize: 12, margin: "4px 0", lineHeight: 1.5 },
//     retryBtn: {
//       marginTop: 20, background: "#c8102e", color: "#fff", border: "none",
//       padding: "13px 32px", borderRadius: 40, fontSize: 15, fontWeight: 700, cursor: "pointer",
//     },
//     progressContainer: { width: "100%", marginTop: 20 },
//     progressBar: {
//       height: 8, background: "#c8102e", borderRadius: 4,
//       position: "relative", overflow: "hidden", transition: "width 0.4s ease",
//     },
//     progressGlow: {
//       position: "absolute", inset: 0,
//       background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)",
//       animation: "shimmer 1.5s infinite",
//     },
//     progressPct: { marginTop: 8, fontSize: 13, fontWeight: 600, color: "#c8102e" },
//     rippleEl: {
//     position: "absolute",
//     inset: 0,
//     borderRadius: 56,
//     border: "2px solid #c8102e",
//     opacity: 0,
//     pointerEvents: "none",
//   },
    
//   };

//   export default QREntryPage;


// import React, { useEffect, useState, useRef, useCallback } from "react";
// import { useNavigate } from "react-router-dom";
// import { getdata, getLogoContent } from "../api/service";
// import QRScanner from './QRScanner';

// const BASE_API = "https://uat-ecom.azurewebsites.net"; // kept for reference; no longer used for table lookups

// function QREntryPage() {
//   const navigate = useNavigate();
//   const [status, setStatus] = useState("scanning");
//   const [progress, setProgress] = useState(0);
//   const [storeInfo, setStoreInfo] = useState(null);
//   const [error, setError] = useState(null);
//   const [cameraActive, setCameraActive] = useState(false);
//   const [cameraError, setCameraError] = useState(null);
//   const [scanFeedback, setScanFeedback] = useState(null);
//   const [showScanner, setShowScanner] = useState(false);

//   const hasNavigated = useRef(false);
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);
//   const streamRef = useRef(null);
//   const scanLoopRef = useRef(null);
//   const jsQRRef = useRef(null);

//   // ── Demo values (storeId + companyId only, no table) ────────────────────────
//   const DEMO_STORE_ID = "567";
//   const DEMO_COMPANY_ID = "5";

//   const handleDemoMode = () => {
//     if (hasNavigated.current) return;
//     stopCamera();
//     processQRScan(DEMO_STORE_ID, DEMO_COMPANY_ID);
//   };

//   // ── Load jsQR dynamically (for desktop live-camera fallback) ────────────────a
//   const loadJsQR = useCallback(() => {
//     return new Promise((resolve, reject) => {
//       if (jsQRRef.current) return resolve(jsQRRef.current);
//       if (window.jsQR) { jsQRRef.current = window.jsQR; return resolve(window.jsQR); }
//       const script = document.createElement("script");
//       script.src = "https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js";
//       script.onload = () => { jsQRRef.current = window.jsQR; resolve(window.jsQR); };
//       script.onerror = () => reject(new Error("Failed to load QR scanner"));
//       document.head.appendChild(script);
//     });
//   }, []);

//   // ── Parse a scanned QR value → { storeId, companyId } ───────────────────────
//   // QR now only ever encodes storeId + companyId — no table, no token.
//   const parseQRUrl = (text) => {
//     try {
//       let url;
//       try { url = new URL(text); } catch { return null; }

//       let storeId   = url.searchParams.get("storeId");
//       let companyId = url.searchParams.get("companyId");

//       if ((!storeId || !companyId) && url.hash?.includes("?")) {
//         const hashParams = new URLSearchParams(url.hash.split("?")[1]);
//         storeId   = storeId   || hashParams.get("storeId");
//         companyId = companyId || hashParams.get("companyId");
//       }

//       if (storeId && companyId) return { storeId, companyId };
//       return null;
//     } catch {
//       return null;
//     }
//   };

//   // ── Stop camera stream ────────────────────────────────────────────────────
//   const stopCamera = useCallback(() => {
//     if (scanLoopRef.current) cancelAnimationFrame(scanLoopRef.current);
//     if (streamRef.current) {
//       streamRef.current.getTracks().forEach(t => t.stop());
//       streamRef.current = null;
//     }
//     setCameraActive(false);
//   }, []);

//   // ── Mobile scanner result ────────────────────────────────────────────────
//   const handleScan = (text) => {
//     setShowScanner(false);
//     const parsed = parseQRUrl(text);
//     if (parsed) {
//       processQRScan(parsed.storeId, parsed.companyId);
//     } else {
//       setCameraError("Invalid QR Code");
//     }
//   };

//   // ── Live browser scan (desktop / HTTPS fallback) ────────────────────────────
//   const startCamera = useCallback(async () => {
//     setCameraError(null);
//     setScanFeedback(null);
//     if (!window.isSecureContext) {
//       setCameraError("Camera requires HTTPS. Please open this page over a secure connection.");
//       return;
//     }
//     if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//       setCameraError("Live scan not supported on this browser. Use the camera button above.");
//       return;
//     }
//     try {
//       const jsQR = await loadJsQR();
//       const stream = await navigator.mediaDevices.getUserMedia({
//         video: {
//           facingMode: { ideal: "environment" },
//           width: { ideal: 1280 },
//           height: { ideal: 720 },
//         }
//       });
//       streamRef.current = stream;
//       setCameraActive(true);
//       await new Promise(r => setTimeout(r, 100));
//       if (videoRef.current) {
//         videoRef.current.srcObject = stream;
//         await videoRef.current.play();
//       }
//       const scan = () => {
//         if (!videoRef.current || !canvasRef.current) return;
//         const video = videoRef.current;
//         const canvas = canvasRef.current;
//         if (video.readyState === video.HAVE_ENOUGH_DATA) {
//           canvas.width = video.videoWidth;
//           canvas.height = video.videoHeight;
//           const ctx = canvas.getContext("2d");
//           ctx.drawImage(video, 0, 0);
//           const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
//           const code = jsQR(imageData.data, imageData.width, imageData.height, {
//             inversionAttempts: "dontInvert",
//           });
//           if (code?.data) {
//             const parsed = parseQRUrl(code.data);
//             if (parsed) {
//               setScanFeedback("QR detected! Processing...");
//               stopCamera();
//               processQRScan(parsed.storeId, parsed.companyId);
//               return;
//             } else {
//               setScanFeedback("QR found but not a valid store QR");
//             }
//           }
//         }
//         scanLoopRef.current = requestAnimationFrame(scan);
//       };
//       scanLoopRef.current = requestAnimationFrame(scan);
//     } catch (err) {
//       setCameraActive(false);
//       if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
//         setCameraError("Camera access denied. Please allow camera permission and try again.");
//       } else if (err.name === "NotFoundError") {
//         setCameraError("No camera found on this device.");
//       } else {
//         setCameraError(err.message || "Could not open camera.");
//       }
//     }
//   }, [loadJsQR, stopCamera]);

//   // ── Smart open: native scanner on mobile, live scan on desktop ──────────────
//   const handleOpenCamera = () => {
//     const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
//     if (isMobile) {
//       setShowScanner(true);
//     } else {
//       startCamera();
//     }
//   };

//   // ── Cleanup on unmount ────────────────────────────────────────────────────
//   useEffect(() => {
//     return () => stopCamera();
//   }, [stopCamera]);

//   // ── URL param extraction (deep-link scan, e.g. opened via QR redirect) ──────
//   useEffect(() => {
//     const extractParams = () => {
//       const searchParams = new URLSearchParams(window.location.search);
//       const hash = window.location.hash;

//       let storeId   = searchParams.get("storeId");
//       let companyId = searchParams.get("companyId");

//       if ((!storeId || !companyId) && hash.includes("?")) {
//         const hashParams = new URLSearchParams(hash.split("?")[1]);
//         storeId   = storeId   || hashParams.get("storeId");
//         companyId = companyId || hashParams.get("companyId");
//       }

//       if (storeId && companyId) {
//         // Clean the URL so nothing lingers in the address bar
//         window.history.replaceState({}, document.title, window.location.pathname);
//       }

//       return { storeId, companyId };
//     };

//     const { storeId, companyId } = extractParams();
//     if (storeId && companyId) {
//       processQRScan(storeId, companyId);
//     } else {
//       setStatus("ready");
//     }

//     const onHashChange = () => {
//       if (hasNavigated.current) return;
//       const { storeId, companyId } = extractParams();
//       if (storeId && companyId) processQRScan(storeId, companyId);
//     };
//     window.addEventListener("hashchange", onHashChange);
//     return () => window.removeEventListener("hashchange", onHashChange);
//   }, []);

//   // ── Main QR process — storeId + companyId only, no table, no GPS check ──────
//   const processQRScan = async (storeId, companyId) => {
//     if (hasNavigated.current) return;
//     hasNavigated.current = true;

//     localStorage.removeItem("cart");
//     localStorage.removeItem("selectedFreeItems");
//     localStorage.removeItem("allowedFreeQty");

//     try {
//       setStatus("processing");
//       setProgress(30);

//       const dataRes = await getdata(companyId, storeId);
//       const info = dataRes?.datas?.[0];
//       const companyName = info?.companyName || "Restaurant";
//       const storeName = info?.storeName || "Branch";
//       setProgress(65);

//       let logoUrl = "";
//       try {
//         const logoRes = await getLogoContent(companyId);
//         logoUrl = logoRes?.logo?.[0]?.url || "https://bizdomfs.blob.core.windows.net/post-image/default.png";
//       } catch {
//         logoUrl = "https://bizdomfs.blob.core.windows.net/post-image/default.png";
//       }

//       localStorage.setItem("StoreId", storeId);
//       localStorage.setItem("compId", companyId);
//       localStorage.setItem("CompanyName", companyName);
//       localStorage.setItem("StoreName", storeName);
//       localStorage.setItem("logo", logoUrl);
//       localStorage.setItem("orderType", "Dine In");
//       localStorage.setItem("ordertypeId", "1");
//       localStorage.setItem("layoutPosition", "top");
//       localStorage.setItem("qrVerifiedAt", Date.now().toString());

//       setStoreInfo({ storeId, companyId, companyName, storeName });
//       setProgress(100);
//       setStatus("success");

//       setTimeout(() => {
//         navigate("/menu", { replace: true, state: { storeId, companyId, isQROrder: true } });
//       }, 1000);
//     } catch (err) {
//       console.error("QR process error:", err);
//       setStatus("error");
//       setError(err.message || "QR processing failed");
//       hasNavigated.current = false;
//     }
//   };

//   const ProgressBar = () => (
//     <div style={styles.progressContainer}>
//       <div style={{ ...styles.progressBar, width: `${progress}%` }}>
//         <div style={styles.progressGlow} />
//       </div>
//       <div style={styles.progressPct}>{progress}%</div>
//     </div>
//   );

//   const renderContent = () => {
//     switch (status) {
//       case "ready":
//         return (
//           <div style={styles.centerBox}>
//             <p style={styles.sub}>Point your camera at the store's QR code</p>

//             <canvas ref={canvasRef} style={{ display: "none" }} />

//             {cameraActive ? (
//               <div style={styles.cameraWrap}>
//                 <video ref={videoRef} style={styles.cameraVideo} playsInline muted autoPlay />
//                 <div style={styles.scanOverlay}>
//                   <div style={styles.scanBox}>
//                     <div style={{ ...styles.scanCorner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
//                     <div style={{ ...styles.scanCorner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
//                     <div style={{ ...styles.scanCorner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
//                     <div style={{ ...styles.scanCorner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
//                     <div style={styles.scanLine} />
//                   </div>
//                   <p style={styles.scanHint}>{scanFeedback || "Align QR code within the frame"}</p>
//                 </div>
//                 <button onClick={stopCamera} style={styles.closeCameraBtn}>✕ Close</button>
//               </div>
//             ) : (
//               <>
//                 <div style={styles.scanFrame}>
//                   <div style={styles.scanLineStatic} />
//                   <div style={{ ...styles.corner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
//                   <div style={{ ...styles.corner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
//                   <div style={{ ...styles.corner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
//                   <div style={{ ...styles.corner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
//                 </div>

//                 {cameraError && (
//                   <div style={styles.cameraErrorBox}>
//                     <span style={{ fontSize: 16 }}>⚠️</span>
//                     <span style={{ fontSize: 12, color: "#9b0d22" }}>{cameraError}</span>
//                   </div>
//                 )}

//                 <div style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
//                   <button onClick={() => setShowScanner(true)} style={styles.openCameraBtn}>
//                     📷 Open Camera &amp; Scan QR
//                   </button>
//                   {showScanner && (
//                     <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />
//                   )}
//                 </div>

//                 <button onClick={handleDemoMode} style={styles.demoBtn}>Demo Mode</button>
//               </>
//             )}
//           </div>
//         );

//       case "processing":
//         return (
//           <div style={styles.centerBox}>
//             <div style={styles.spinner} />
//             <h2 style={styles.h2}>Loading Store...</h2>
//             <p style={styles.sub}>Setting up your menu</p>
//             <ProgressBar />
//           </div>
//         );

//       case "success":
//         return (
//           <div style={styles.centerBox}>
//             <div style={styles.successCircle}>
//               <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
//                 <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" />
//               </svg>
//             </div>
//             <h2 style={styles.h2}>Welcome! {storeInfo?.companyName}</h2>
//             <p style={styles.sub}>{storeInfo?.storeName}</p>
//             <p style={{ ...styles.sub, color: "#999", marginTop: 16 }}>Taking you to the menu...</p>
//           </div>
//         );

//       case "error":
//         return (
//           <div style={styles.centerBox}>
//             <span style={{ fontSize: 56 }}>⚠️</span>
//             <h2 style={{ ...styles.h2, marginTop: 16 }}>Unable to Process QR Code</h2>
//             <p style={styles.sub}>{error || "Failed to process QR code"}</p>
//             <button onClick={() => window.location.reload()} style={styles.retryBtn}>Try Again</button>
//           </div>
//         );

//       default: return null;
//     }
//   };

//   return (
//     <div style={styles.page}>
//       <style>{`
//         @keyframes spin        { to { transform: rotate(360deg); } }
//         @keyframes pulse       { 0% { transform: scale(0.8); opacity: 1; } 100% { transform: scale(2); opacity: 0; } }
//         @keyframes slideUp     { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
//         @keyframes shimmer     { 0% { transform: translateX(-100%); } 100% { transform: translateX(400%); } }
//         @keyframes scanMove       { 0% { top: 8px; opacity: 0.4; } 50% { opacity: 1; } 100% { top: calc(100% - 11px); opacity: 0.4; } }
//         @keyframes scanMoveStatic { 0% { top: 10px; opacity: 0.3; } 50% { opacity: 1; } 100% { top: 150px; opacity: 0.3; } }
//         @keyframes camBtnPulse { 0%,100% { box-shadow: 0 4px 24px rgba(200,16,46,0.35); } 50% { box-shadow: 0 4px 36px rgba(200,16,46,0.6); } }
//       `}</style>
//       <div style={styles.card}>
//         <div style={styles.header}>
//           <h1 style={styles.title}>Scan & Order</h1>
//           <p style={styles.subtitle}>Contactless dining order experience</p>
//         </div>
//         <div style={styles.content}>{renderContent()}</div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   page: {
//     minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
//     fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//     padding: 16, background: "#fff0f0",
//   },
//   card: {
//     width: "100%", maxWidth: 460, background: "#fff",
//     borderRadius: 32, padding: "32px 24px",
//     boxShadow: "0 8px 40px rgba(200,16,46,0.12)",
//     animation: "slideUp 0.5s ease-out",
//     border: "1px solid #fde8e8",
//   },
//   header: { textAlign: "center", marginBottom: 28 },
//   title: { fontSize: 28, fontWeight: 800, color: "#c8102e", margin: 0, letterSpacing: "-0.5px" },
//   subtitle: { color: "#b0a0a0", fontSize: 13, marginTop: 6 },
//   content: { minHeight: 360, display: "flex", alignItems: "center", justifyContent: "center" },
//   centerBox: { textAlign: "center", width: "100%" },
//   h2: { fontSize: 20, color: "#1a1a1a", margin: "16px 0 8px", fontWeight: 700 },
//   sub: { color: "#888", fontSize: 14, lineHeight: 1.6, margin: "4px 16px" },

//   openCameraBtn: {
//     position: "relative", overflow: "hidden", marginTop: 20,
//     display: "inline-flex", alignItems: "center", gap: 12,
//     background: "#c8102e", color: "#fff", border: "none",
//     padding: "16px 32px", borderRadius: 56, fontSize: 15, fontWeight: 700,
//     cursor: "pointer", letterSpacing: 0.3,
//     boxShadow: "0 4px 24px rgba(200,16,46,0.35)",
//     WebkitTapHighlightColor: "transparent",
//     animation: "camBtnPulse 2.5s ease-in-out infinite",
//   },

//   cameraWrap: {
//     position: "relative", width: "100%", borderRadius: 20, overflow: "hidden",
//     background: "#000", marginBottom: 16, aspectRatio: "4/3",
//   },
//   cameraVideo: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
//   scanOverlay: {
//     position: "absolute", inset: 0, display: "flex", flexDirection: "column",
//     alignItems: "center", justifyContent: "center",
//   },
//   scanBox: { position: "relative", width: 200, height: 200, background: "rgba(255,255,255,0.05)" },
//   scanCorner: { position: "absolute", width: 28, height: 28, border: "3px solid #c8102e", borderRadius: 3 },
//   scanLine: {
//     position: "absolute", left: 6, right: 6, height: 3,
//     background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
//     borderRadius: 10, animation: "scanMove 1.8s linear infinite",
//   },
//   scanHint: {
//     marginTop: 16, color: "#fff", fontSize: 12, fontWeight: 600,
//     background: "rgba(0,0,0,0.5)", padding: "6px 16px", borderRadius: 20, letterSpacing: 0.3,
//   },
//   closeCameraBtn: {
//     position: "absolute", top: 12, right: 12,
//     background: "rgba(0,0,0,0.6)", color: "#fff", border: "none",
//     borderRadius: 20, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer",
//   },

//   cameraErrorBox: {
//     display: "flex", alignItems: "center", gap: 8,
//     background: "#fdecea", border: "1px solid #f5c6c6",
//     borderRadius: 12, padding: "10px 16px", margin: "12px 0", textAlign: "left",
//   },

//   scanFrame: {
//     position: "relative", width: 180, height: 180,
//     margin: "16px auto", background: "rgba(200,16,46,0.04)",
//     borderRadius: 20, overflow: "hidden",
//   },
//   scanLineStatic: {
//     position: "absolute", left: 10, right: 10, height: 3,
//     background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
//     borderRadius: 10, animation: "scanMoveStatic 2s linear infinite",
//   },
//   corner: { position: "absolute", width: 36, height: 36, border: "3px solid #c8102e", borderRadius: 4 },

//   demoBtn: {
//     marginTop: 14, padding: "11px 26px", borderRadius: 30,
//     border: "1px solid #f5c6c6", background: "#fff0f0",
//     color: "#c8102e", fontSize: 13, fontWeight: 600, cursor: "pointer",
//   },

//   spinner: {
//     width: 56, height: 56, margin: "0 auto 20px",
//     border: "4px solid #fde8e8", borderTop: "4px solid #c8102e",
//     borderRadius: "50%", animation: "spin 0.9s linear infinite",
//   },
//   successCircle: {
//     width: 80, height: 80, margin: "0 auto 16px",
//     background: "#c8102e", borderRadius: "50%",
//     display: "flex", alignItems: "center", justifyContent: "center",
//   },
//   retryBtn: {
//     marginTop: 20, background: "#c8102e", color: "#fff", border: "none",
//     padding: "13px 32px", borderRadius: 40, fontSize: 15, fontWeight: 700, cursor: "pointer",
//   },
//   progressContainer: { width: "100%", marginTop: 20 },
//   progressBar: {
//     height: 8, background: "#c8102e", borderRadius: 4,
//     position: "relative", overflow: "hidden", transition: "width 0.4s ease",
//   },
//   progressGlow: {
//     position: "absolute", inset: 0,
//     background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)",
//     animation: "shimmer 1.5s infinite",
//   },
//   progressPct: { marginTop: 8, fontSize: 13, fontWeight: 600, color: "#c8102e" },
// };

// export default QREntryPage;

import React, { useEffect, useState, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { getdata, getLogoContent } from "../api/service";
import QRScanner from './QRScanner';

const BASE_API = "https://uat-ecom.azurewebsites.net"; // kept for reference; no longer used for table lookups

function QREntryPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("scanning");
  const [progress, setProgress] = useState(0);
  const [storeInfo, setStoreInfo] = useState(null);
  const [error, setError] = useState(null);
  const [cameraActive, setCameraActive] = useState(false);
  const [cameraError, setCameraError] = useState(null);
  const [scanFeedback, setScanFeedback] = useState(null);
  const [showScanner, setShowScanner] = useState(false);

  const hasNavigated = useRef(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const scanLoopRef = useRef(null);
  const jsQRRef = useRef(null);

  // ── Demo values (storeId + companyId only, no table) ────────────────────────
  const DEMO_STORE_ID ="596";
  const DEMO_COMPANY_ID = "5";

  const handleDemoMode = () => {
    if (hasNavigated.current) return;
    stopCamera();
    processQRScan(DEMO_STORE_ID, DEMO_COMPANY_ID);
  };

  // ── Load jsQR dynamically (for desktop live-camera fallback) ────────────────
  const loadJsQR = useCallback(() => {
    return new Promise((resolve, reject) => {
      if (jsQRRef.current) return resolve(jsQRRef.current);
      if (window.jsQR) { jsQRRef.current = window.jsQR; return resolve(window.jsQR); }
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/jsqr@1.4.0/dist/jsQR.js";
      script.onload = () => { jsQRRef.current = window.jsQR; resolve(window.jsQR); };
      script.onerror = () => reject(new Error("Failed to load QR scanner"));
      document.head.appendChild(script);
    });
  }, []);

  // ── Parse a scanned QR value → { storeId, companyId } ───────────────────────
  // QR encodes storeId|companyId as a base64 token in ?q=... (no table).
  // Plain ?storeId=&companyId= params are still accepted as a fallback.
  const parseQRUrl = (text) => {
    try {
      let url;
      try { url = new URL(text); } catch { return null; }

      const decodeToken = (token) => {
        try {
          const decoded = atob(token);
          const [storeId, companyId] = decoded.split("|");
          if (storeId && companyId) return { storeId, companyId };
        } catch {}
        return null;
      };

      // ── Primary: base64 token ──
      const token = url.searchParams.get("q");
      if (token) {
        const parsed = decodeToken(token);
        if (parsed) return parsed;
      }

      // ── Fallback: plain params ──
      let storeId   = url.searchParams.get("storeId");
      let companyId = url.searchParams.get("companyId");

      if ((!token && (!storeId || !companyId)) && url.hash?.includes("?")) {
        const hashParams = new URLSearchParams(url.hash.split("?")[1]);
        const hashToken = hashParams.get("q");
        if (hashToken) {
          const parsed = decodeToken(hashToken);
          if (parsed) return parsed;
        }
        storeId   = storeId   || hashParams.get("storeId");
        companyId = companyId || hashParams.get("companyId");
      }

      if (storeId && companyId) return { storeId, companyId };
      return null;
    } catch {
      return null;
    }
  };

  // ── Stop camera stream ────────────────────────────────────────────────────
  const stopCamera = useCallback(() => {
    if (scanLoopRef.current) cancelAnimationFrame(scanLoopRef.current);
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(t => t.stop());
      streamRef.current = null;
    }
    setCameraActive(false);
  }, []);

  // ── Mobile scanner result ────────────────────────────────────────────────
  const handleScan = (text) => {
    setShowScanner(false);
    const parsed = parseQRUrl(text);
    if (parsed) {
      processQRScan(parsed.storeId, parsed.companyId);
    } else {
      setCameraError("Invalid QR Code");
    }
  };

  // ── Live browser scan (desktop / HTTPS fallback) ────────────────────────────
  const startCamera = useCallback(async () => {
    setCameraError(null);
    setScanFeedback(null);
    if (!window.isSecureContext) {
      setCameraError("Camera requires HTTPS. Please open this page over a secure connection.");
      return;
    }
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setCameraError("Live scan not supported on this browser. Use the camera button above.");
      return;
    }
    try {
      const jsQR = await loadJsQR();
      const stream = await navigator.mediaDevices.getUserMedia({
        video: {
          facingMode: { ideal: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        }
      });
      streamRef.current = stream;
      setCameraActive(true);
      await new Promise(r => setTimeout(r, 100));
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
        await videoRef.current.play();
      }
      const scan = () => {
        if (!videoRef.current || !canvasRef.current) return;
        const video = videoRef.current;
        const canvas = canvasRef.current;
        if (video.readyState === video.HAVE_ENOUGH_DATA) {
          canvas.width = video.videoWidth;
          canvas.height = video.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(video, 0, 0);
          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
          const code = jsQR(imageData.data, imageData.width, imageData.height, {
            inversionAttempts: "dontInvert",
          });
          if (code?.data) {
            const parsed = parseQRUrl(code.data);
            if (parsed) {
              setScanFeedback("QR detected! Processing...");
              stopCamera();
              processQRScan(parsed.storeId, parsed.companyId);
              return;
            } else {
              setScanFeedback("QR found but not a valid store QR");
            }
          }
        }
        scanLoopRef.current = requestAnimationFrame(scan);
      };
      scanLoopRef.current = requestAnimationFrame(scan);
    } catch (err) {
      setCameraActive(false);
      if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
        setCameraError("Camera access denied. Please allow camera permission and try again.");
      } else if (err.name === "NotFoundError") {
        setCameraError("No camera found on this device.");
      } else {
        setCameraError(err.message || "Could not open camera.");
      }
    }
  }, [loadJsQR, stopCamera]);
const [isOffline, setIsOffline] = useState(!navigator.onLine);
  // ── Smart open: native scanner on mobile, live scan on desktop ──────────────
  const handleOpenCamera = () => {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      setShowScanner(true);
    } else {
      startCamera();
    }
  };

  // ── Cleanup on unmount ────────────────────────────────────────────────────
  useEffect(() => {
    return () => stopCamera();
  }, [stopCamera]);

  // ── URL param extraction (deep-link scan, e.g. opened via QR redirect) ──────
  useEffect(() => {
    const decodeToken = (token) => {
      try {
        const decoded = atob(token);
        const [storeId, companyId] = decoded.split("|");
        if (storeId && companyId) return { storeId, companyId };
      } catch {}
      return null;
    };

    const extractParams = () => {
      const searchParams = new URLSearchParams(window.location.search);
      const hash = window.location.hash;

      // ── Primary: base64 token ──
      let token = searchParams.get("q");
      if (!token && hash.includes("?")) {
        const hashParams = new URLSearchParams(hash.split("?")[1]);
        token = hashParams.get("q");
      }
      if (token) {
        const parsed = decodeToken(token);
        if (parsed) {
          window.history.replaceState({}, document.title, window.location.pathname);
          return parsed;
        }
      }

      // ── Fallback: plain params ──
      let storeId   = searchParams.get("storeId");
      let companyId = searchParams.get("companyId");

      if ((!storeId || !companyId) && hash.includes("?")) {
        const hashParams = new URLSearchParams(hash.split("?")[1]);
        storeId   = storeId   || hashParams.get("storeId");
        companyId = companyId || hashParams.get("companyId");
      }

      if (storeId && companyId) {
        window.history.replaceState({}, document.title, window.location.pathname);
        return { storeId, companyId };
      }

      return { storeId: null, companyId: null };
    };

    const { storeId, companyId } = extractParams();
    if (storeId && companyId) {
      processQRScan(storeId, companyId);
    } else {
      setStatus("ready");
    }

    const onHashChange = () => {
      if (hasNavigated.current) return;
      const { storeId, companyId } = extractParams();
      if (storeId && companyId) processQRScan(storeId, companyId);
    };
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);
useEffect(() => {
  const goOffline = () => setIsOffline(true);
  const goOnline  = () => setIsOffline(false);
  window.addEventListener("offline", goOffline);
  window.addEventListener("online", goOnline);
  return () => {
    window.removeEventListener("offline", goOffline);
    window.removeEventListener("online", goOnline);
  };
}, []);
  // ── Main QR process — storeId + companyId only, no table, no GPS check ──────
  // const processQRScan = async (storeId, companyId) => {
  //   if (hasNavigated.current) return;
  //   hasNavigated.current = true;

  //   localStorage.removeItem("cart");
  //   localStorage.removeItem("selectedFreeItems");
  //   localStorage.removeItem("allowedFreeQty");

  //   try {
  //     setStatus("processing");
  //     setProgress(30);

  //     const dataRes = await getdata(companyId, storeId);
  //     const info = dataRes?.datas?.[0];
  //     const companyName = info?.companyName || "Restaurant";
  //     const storeName = info?.storeName || "Branch";
  //     setProgress(65);

  //     let logoUrl = "";
  //     try {
  //       const logoRes = await getLogoContent(companyId);
  //       logoUrl = logoRes?.logo?.[0]?.url || "https://bizdomfs.blob.core.windows.net/post-image/default.png";
  //     } catch {
  //       logoUrl = "https://bizdomfs.blob.core.windows.net/post-image/default.png";
  //     }

  //     localStorage.setItem("StoreId", storeId);
  //     localStorage.setItem("compId", companyId);
  //     localStorage.setItem("CompanyName", companyName);
  //     localStorage.setItem("StoreName", storeName);
  //     localStorage.setItem("logo", logoUrl);
  //     localStorage.setItem("orderType", "Dine In");
  //     localStorage.setItem("ordertypeId", "1");
  //     localStorage.setItem("layoutPosition", "top");
  //     localStorage.setItem("qrVerifiedAt", Date.now().toString());

  //     setStoreInfo({ storeId, companyId, companyName, storeName });
  //     setProgress(100);
  //     setStatus("success");

  //     setTimeout(() => {
  //       navigate("/menu", { replace: true, state: { storeId, companyId, isQROrder: true } });
  //     }, 1000);
  //   } catch (err) {
  //     console.error("QR process error:", err);
  //     setStatus("error");
  //     setError(err.message || "QR processing failed");
  //     hasNavigated.current = false;
  //   }
  // };
const processQRScan = async (storeId, companyId) => {
  if (hasNavigated.current) return;
  hasNavigated.current = true;

  localStorage.removeItem("cart");
  localStorage.removeItem("selectedFreeItems");
  localStorage.removeItem("allowedFreeQty");

  // ── Explicit offline check before even attempting the call ──
  if (!navigator.onLine) {
    setStatus("error");
    setError("You appear to be offline. Please check your connection and try again.");
    hasNavigated.current = false;
    return;
  }

  try {
    setStatus("processing");
    setProgress(30);

    const dataRes = await getdata(companyId, storeId);
    const info = dataRes?.datas?.[0];

    // ── Reject silently-empty responses instead of falling to placeholders ──
    if (!info?.companyName || !info?.storeName) {
      throw new Error("Store details unavailable — please check your connection and try again.");
    }

    const companyName = info.companyName;
    const storeName = info.storeName;
    setProgress(65);

    let logoUrl = "";
    try {
      const logoRes = await getLogoContent(companyId);
      logoUrl = logoRes?.logo?.[0]?.url || "https://bizdomfs.blob.core.windows.net/post-image/default.png";
    } catch {
      logoUrl = "https://bizdomfs.blob.core.windows.net/post-image/default.png";
    }

    localStorage.setItem("StoreId", storeId);
    localStorage.setItem("compId", companyId);
    localStorage.setItem("CompanyName", companyName);
    localStorage.setItem("StoreName", storeName);
    localStorage.setItem("logo", logoUrl);
    localStorage.setItem("orderType", "Dine In");
    localStorage.setItem("ordertypeId", "1");
    localStorage.setItem("layoutPosition", "top");
    localStorage.setItem("qrVerifiedAt", Date.now().toString());

    setStoreInfo({ storeId, companyId, companyName, storeName });
    setProgress(100);
    setStatus("success");

    setTimeout(() => {
      navigate("/menu", { replace: true, state: { storeId, companyId, isQROrder: true } });
    }, 1000);
  } catch (err) {
    console.error("QR process error:", err);
    setStatus("error");
    setError(
      !navigator.onLine
        ? "You appear to be offline. Please check your connection and try again."
        : err.message || "QR processing failed"
    );
    hasNavigated.current = false;
  }
};
  const ProgressBar = () => (
    <div style={styles.progressContainer}>
      <div style={{ ...styles.progressBar, width: `${progress}%` }}>
        <div style={styles.progressGlow} />
      </div>
      <div style={styles.progressPct}>{progress}%</div>
    </div>
  );

  const renderContent = () => {
    switch (status) {
      case "ready":
        return (
          <div style={styles.centerBox}>
            <p style={styles.sub}>Point your camera at the store's QR code</p>

            <canvas ref={canvasRef} style={{ display: "none" }} />

            {cameraActive ? (
              <div style={styles.cameraWrap}>
                <video ref={videoRef} style={styles.cameraVideo} playsInline muted autoPlay />
                <div style={styles.scanOverlay}>
                  <div style={styles.scanBox}>
                    <div style={{ ...styles.scanCorner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
                    <div style={{ ...styles.scanCorner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
                    <div style={{ ...styles.scanCorner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
                    <div style={{ ...styles.scanCorner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
                    <div style={styles.scanLine} />
                  </div>
                  <p style={styles.scanHint}>{scanFeedback || "Align QR code within the frame"}</p>
                </div>
                <button onClick={stopCamera} style={styles.closeCameraBtn}>✕ Close</button>
              </div>
            ) : (
              <>
                <div style={styles.scanFrame}>
                  <div style={styles.scanLineStatic} />
                  <div style={{ ...styles.corner, top: 0, left: 0, borderRight: "none", borderBottom: "none" }} />
                  <div style={{ ...styles.corner, top: 0, right: 0, borderLeft: "none", borderBottom: "none" }} />
                  <div style={{ ...styles.corner, bottom: 0, left: 0, borderRight: "none", borderTop: "none" }} />
                  <div style={{ ...styles.corner, bottom: 0, right: 0, borderLeft: "none", borderTop: "none" }} />
                </div>

                {cameraError && (
                  <div style={styles.cameraErrorBox}>
                    <span style={{ fontSize: 16 }}>⚠️</span>
                    <span style={{ fontSize: 12, color: "#9b0d22" }}>{cameraError}</span>
                  </div>
                )}

                <div style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center", marginTop: 20 }}>
                  <button onClick={handleOpenCamera} style={styles.openCameraBtn}>
                    📷 Open Camera &amp; Scan QR
                  </button>
                  {showScanner && (
                    <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />
                  )}
                </div>

                {/* <button onClick={handleDemoMode} style={styles.demoBtn}>Demo Mode</button> */}
              </>
            )}
          </div>
        );

      case "processing":
        return (
          <div style={styles.centerBox}>
            <div style={styles.spinner} />
            <h2 style={styles.h2}>Loading Store...</h2>
            <p style={styles.sub}>Setting up your menu</p>
            <ProgressBar />
          </div>
        );

      case "success":
        return (
          <div style={styles.centerBox}>
            <div style={styles.successCircle}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17L4 12" stroke="white" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>
            <h2 style={styles.h2}>Welcome! {storeInfo?.companyName}</h2>
            <p style={styles.sub}>{storeInfo?.storeName}</p>
            <p style={{ ...styles.sub, color: "#999", marginTop: 16 }}>Taking you to the menu...</p>
          </div>
        );

      // case "error":
      //   return (
      //     <div style={styles.centerBox}>
      //       <span style={{ fontSize: 56 }}>⚠️</span>
      //       <h2 style={{ ...styles.h2, marginTop: 16 }}>Unable to Process QR Code</h2>
      //       <p style={styles.sub}>{error || "Failed to process QR code"}</p>
      //       <button onClick={() => window.location.reload()} style={styles.retryBtn}>Try Again</button>
      //     </div>
      //   );
case "error":
  return (
    <div style={styles.centerBox}>
      <span style={{ fontSize: 56 }}>{isOffline ? "📡" : "⚠️"}</span>
      <h2 style={{ ...styles.h2, marginTop: 16 }}>
        {isOffline ? "No Internet Connection" : "Unable to Process QR Code"}
      </h2>
      <p style={styles.sub}>
        {isOffline
          ? "Please check your Wi-Fi or mobile data and try again."
          : (error || "Failed to process QR code")}
      </p>
      <button onClick={() => window.location.reload()} style={styles.retryBtn}>
        Try Again
      </button>
    </div>
  );
      default: return null;
    }
  };

  return (
    <div style={styles.page}>
      <style>{`
        @keyframes spin        { to { transform: rotate(360deg); } }
        @keyframes pulse       { 0% { transform: scale(0.8); opacity: 1; } 100% { transform: scale(2); opacity: 0; } }
        @keyframes slideUp     { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes shimmer     { 0% { transform: translateX(-100%); } 100% { transform: translateX(400%); } }
        @keyframes scanMove       { 0% { top: 8px; opacity: 0.4; } 50% { opacity: 1; } 100% { top: calc(100% - 11px); opacity: 0.4; } }
        @keyframes scanMoveStatic { 0% { top: 10px; opacity: 0.3; } 50% { opacity: 1; } 100% { top: 150px; opacity: 0.3; } }
        @keyframes camBtnPulse { 0%,100% { box-shadow: 0 4px 24px rgba(200,16,46,0.35); } 50% { box-shadow: 0 4px 36px rgba(200,16,46,0.6); } }
      `}</style>
      <div style={styles.card}>
        <div style={styles.header}>
          <h1 style={styles.title}>Scan & Order</h1>
          <p style={styles.subtitle}>Contactless dining order experience</p>
        </div>
        <div style={styles.content}>{renderContent()}</div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    padding: 16, background: "#fff0f0",
  },
  card: {
    width: "100%", maxWidth: 460, background: "#fff",
    borderRadius: 32, padding: "32px 24px",
    boxShadow: "0 8px 40px rgba(200,16,46,0.12)",
    animation: "slideUp 0.5s ease-out",
    border: "1px solid #fde8e8",
  },
  header: { textAlign: "center", marginBottom: 28 },
  title: { fontSize: 28, fontWeight: 800, color: "#c8102e", margin: 0, letterSpacing: "-0.5px" },
  subtitle: { color: "#b0a0a0", fontSize: 13, marginTop: 6 },
  content: { minHeight: 360, display: "flex", alignItems: "center", justifyContent: "center" },
  centerBox: { textAlign: "center", width: "100%" },
  h2: { fontSize: 20, color: "#1a1a1a", margin: "16px 0 8px", fontWeight: 700 },
  sub: { color: "#888", fontSize: 14, lineHeight: 1.6, margin: "4px 16px" },

  openCameraBtn: {
    position: "relative", overflow: "hidden", marginTop: 20,
    display: "inline-flex", alignItems: "center", gap: 12,
    background: "#c8102e", color: "#fff", border: "none",
    padding: "16px 32px", borderRadius: 56, fontSize: 15, fontWeight: 700,
    cursor: "pointer", letterSpacing: 0.3,
    boxShadow: "0 4px 24px rgba(200,16,46,0.35)",
    WebkitTapHighlightColor: "transparent",
    animation: "camBtnPulse 2.5s ease-in-out infinite",
  },

  cameraWrap: {
    position: "relative", width: "100%", borderRadius: 20, overflow: "hidden",
    background: "#000", marginBottom: 16, aspectRatio: "4/3",
  },
  cameraVideo: { width: "100%", height: "100%", objectFit: "cover", display: "block" },
  scanOverlay: {
    position: "absolute", inset: 0, display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
  },
  scanBox: { position: "relative", width: 200, height: 200, background: "rgba(255,255,255,0.05)" },
  scanCorner: { position: "absolute", width: 28, height: 28, border: "3px solid #c8102e", borderRadius: 3 },
  scanLine: {
    position: "absolute", left: 6, right: 6, height: 3,
    background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
    borderRadius: 10, animation: "scanMove 1.8s linear infinite",
  },
  scanHint: {
    marginTop: 16, color: "#fff", fontSize: 12, fontWeight: 600,
    background: "rgba(0,0,0,0.5)", padding: "6px 16px", borderRadius: 20, letterSpacing: 0.3,
  },
  closeCameraBtn: {
    position: "absolute", top: 12, right: 12,
    background: "rgba(0,0,0,0.6)", color: "#fff", border: "none",
    borderRadius: 20, padding: "6px 14px", fontSize: 13, fontWeight: 600, cursor: "pointer",
  },

  cameraErrorBox: {
    display: "flex", alignItems: "center", gap: 8,
    background: "#fdecea", border: "1px solid #f5c6c6",
    borderRadius: 12, padding: "10px 16px", margin: "12px 0", textAlign: "left",
  },

  scanFrame: {
    position: "relative", width: 180, height: 180,
    margin: "16px auto", background: "rgba(200,16,46,0.04)",
    borderRadius: 20, overflow: "hidden",
  },
  scanLineStatic: {
    position: "absolute", left: 10, right: 10, height: 3,
    background: "linear-gradient(90deg, transparent, #c8102e, transparent)",
    borderRadius: 10, animation: "scanMoveStatic 2s linear infinite",
  },
  corner: { position: "absolute", width: 36, height: 36, border: "3px solid #c8102e", borderRadius: 4 },

  demoBtn: {
    marginTop: 14, padding: "11px 26px", borderRadius: 30,
    border: "1px solid #f5c6c6", background: "#fff0f0",
    color: "#c8102e", fontSize: 13, fontWeight: 600, cursor: "pointer",
  },

  spinner: {
    width: 56, height: 56, margin: "0 auto 20px",
    border: "4px solid #fde8e8", borderTop: "4px solid #c8102e",
    borderRadius: "50%", animation: "spin 0.9s linear infinite",
  },
  successCircle: {
    width: 80, height: 80, margin: "0 auto 16px",
    background: "#c8102e", borderRadius: "50%",
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  retryBtn: {
    marginTop: 20, background: "#c8102e", color: "#fff", border: "none",
    padding: "13px 32px", borderRadius: 40, fontSize: 15, fontWeight: 700, cursor: "pointer",
  },
  progressContainer: { width: "100%", marginTop: 20 },
  progressBar: {
    height: 8, background: "#c8102e", borderRadius: 4,
    position: "relative", overflow: "hidden", transition: "width 0.4s ease",
  },
  progressGlow: {
    position: "absolute", inset: 0,
    background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.35), transparent)",
    animation: "shimmer 1.5s infinite",
  },
  progressPct: { marginTop: 8, fontSize: 13, fontWeight: 600, color: "#c8102e" },
};

export default QREntryPage;